import { Component, Input, OnInit } from '@angular/core'
import { PropertySearcher } from '../../helpers/property-searcher.helper';
import { ComponentConfiguration } from '../../models/component-config.model';
import { ActionMenuViewComponent } from '../action-menu-view/action-menu-view.component';
import { OrderActionsCommonViewComponent } from '../order-actions-common-view/order-actions-common-view.component';
import { OrderExecutersCommonViewComponent } from '../order-executers-common-view/order-executers-common-view.component';
import { OrderIdentificatorCommonViewComponent } from '../order-identificator-common-view/order-identificator-common-view.component';
import { OrderMarkersCommonViewComponent } from '../order-markers-common-view/order-markers-common-view.component';

@Component({
  selector: 'app-order-common-row-view',
  templateUrl: './order-common-row-view.component.html',
  styleUrls: ['./order-common-row-view.component.scss'],
})
export class OrderCommonRowViewComponent implements OnInit {
  @Input() data: unknown;

  identificatorConfig: ComponentConfiguration = { componentType: OrderIdentificatorCommonViewComponent, withParseData: true };
  markersConfig: ComponentConfiguration = { componentType: OrderMarkersCommonViewComponent, withParseData: true  };
  executersConfig: ComponentConfiguration = { componentType: OrderExecutersCommonViewComponent, withParseData: true  };
  actionsConfig: ComponentConfiguration = { componentType: OrderActionsCommonViewComponent, withParseData: true  };
  actionMenuConfig: ComponentConfiguration = { componentType: ActionMenuViewComponent, withParseData: true  };

  ngOnInit() {
    this.identificatorConfig.actualData = PropertySearcher.findValue(this.data, 'identifier');
    this.markersConfig.actualData = PropertySearcher.findValue(this.data, 'markers');
    this.executersConfig.actualData = PropertySearcher.findValue(this.data, 'executers');
    this.actionsConfig.actualData = PropertySearcher.findValue(this.data, 'actions')
    this.actionMenuConfig.actualData = PropertySearcher.findValue(this.data, 'actionMenu')
  }
}
